export enum CustomerMeetingUserState {
  Active = 'active',
  NotActive = 'not_active',
}

export enum CustomerMeetingUserAccess {
  Access = 'access',
  NoAccess = 'no_access',
}

export interface CustomerMeetingUser {
  id: string;
  permission: CustomerMeetingUserAccess;
  state: CustomerMeetingUserState;
}
